import { GetProjectsResponse } from "api/generatedApi";
import { createContext, useContext } from "react";

interface ProjectsContextType {
  projects: GetProjectsResponse | undefined;
  hideProjectMutation: (projectId: string) => Promise<void>;
  unhideProjectMutation: (projectId: string) => Promise<void>;
  refetchProjects: () => void;
}

export const ProjectsContext = createContext<ProjectsContextType | null>(null);

export const useProjects = () => {
  const context = useContext(ProjectsContext);
  if (!context) {
    throw new Error("useProjects must be used within a ProjectsProvider");
  }
  return context;
};
